import { Component, EventEmitter, Input, Output } from '@angular/core'
import { SafeResourceUrl } from '@angular/platform-browser'

@Component({
  selector: 'app-daily-log-content-edit',
  templateUrl: './daily-log-content-edit.component.html',
  styleUrls: ['./daily-log-content-edit.component.scss'],
})
export class DailyLogContentEditComponent {
  constructor() {}

  @Input() bgColor: string | undefined
  @Input() content: string | undefined
  @Input() photoUrl: SafeResourceUrl | undefined
  @Input() isEditable = false
  @Output() onContentChange = new EventEmitter<string>()
}
